var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.extRender || []),function(item,index){return _c(item,{key:index,ref:item,refInFor:true,tag:"component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }